
export default {
    couponCodeList: [],
    currentCouponObject:{}
};
